/**
 * Generated by orval v8.7.0 🍺
 * Do not edit manually.
 * Api
 * CPL Exam Prep API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AnswerRecord,
  AnswerResult,
  BankCounts,
  BulkCreateQuestionsBody,
  BulkImportResult,
  CategoryStat,
  CreateQuestionBody,
  CreateSessionBody,
  ErrorResponse,
  GetCategoryStatsParams,
  GetStatsMilestonesParams,
  GetStatsOverviewParams,
  GetWeaknessesParams,
  HealthStatus,
  ListQuestionsParams,
  Question,
  Session,
  StatsMilestones,
  StatsOverview,
  SubmitAnswerBody,
  UpdateSessionBody,
  WeaknessEntry
} from './api.schemas';

import { customFetch } from '../custom-fetch';
import type { ErrorType , BodyType } from '../custom-fetch';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Returns server health status
 * @summary Health check
 */
export const getHealthCheckUrl = () => {




  return `/api/healthz`
}

export const healthCheck = async ( options?: RequestInit): Promise<HealthStatus> => {

  return customFetch<HealthStatus>(getHealthCheckUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHealthCheckQueryKey = () => {
    return [
    `/api/healthz`
    ] as const;
    }


export const getHealthCheckQueryOptions = <TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthCheckQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({ signal }) => healthCheck({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData> & { queryKey: QueryKey }
}

export type HealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof healthCheck>>>
export type HealthCheckQueryError = ErrorType<unknown>


/**
 * @summary Health check
 */

export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getHealthCheckQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary List all questions
 */
export const getListQuestionsUrl = (params?: ListQuestionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/questions?${stringifiedParams}` : `/api/questions`
}

export const listQuestions = async (params?: ListQuestionsParams, options?: RequestInit): Promise<Question[]> => {

  return customFetch<Question[]>(getListQuestionsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListQuestionsQueryKey = (params?: ListQuestionsParams,) => {
    return [
    `/api/questions`, ...(params ? [params] : [])
    ] as const;
    }


export const getListQuestionsQueryOptions = <TData = Awaited<ReturnType<typeof listQuestions>>, TError = ErrorType<unknown>>(params?: ListQuestionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listQuestions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListQuestionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listQuestions>>> = ({ signal }) => listQuestions(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listQuestions>>, TError, TData> & { queryKey: QueryKey }
}

export type ListQuestionsQueryResult = NonNullable<Awaited<ReturnType<typeof listQuestions>>>
export type ListQuestionsQueryError = ErrorType<unknown>


/**
 * @summary List all questions
 */

export function useListQuestions<TData = Awaited<ReturnType<typeof listQuestions>>, TError = ErrorType<unknown>>(
 params?: ListQuestionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listQuestions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListQuestionsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Create a new question
 */
export const getCreateQuestionUrl = () => {




  return `/api/questions`
}

export const createQuestion = async (createQuestionBody: CreateQuestionBody, options?: RequestInit): Promise<Question> => {

  return customFetch<Question>(getCreateQuestionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createQuestionBody,)
  }
);}




export const getCreateQuestionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createQuestion>>, TError,{data: BodyType<CreateQuestionBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createQuestion>>, TError,{data: BodyType<CreateQuestionBody>}, TContext> => {

const mutationKey = ['createQuestion'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createQuestion>>, {data: BodyType<CreateQuestionBody>}> = (props) => {
          const {data} = props ?? {};

          return  createQuestion(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateQuestionMutationResult = NonNullable<Awaited<ReturnType<typeof createQuestion>>>
    export type CreateQuestionMutationBody = BodyType<CreateQuestionBody>
    export type CreateQuestionMutationError = ErrorType<unknown>

    /**
 * @summary Create a new question
 */
export const useCreateQuestion = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createQuestion>>, TError,{data: BodyType<CreateQuestionBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createQuestion>>,
        TError,
        {data: BodyType<CreateQuestionBody>},
        TContext
      > => {
      return useMutation(getCreateQuestionMutationOptions(options));
    }

/**
 * @summary Bulk import questions
 */
export const getBulkCreateQuestionsUrl = () => {




  return `/api/questions/bulk`
}

export const bulkCreateQuestions = async (bulkCreateQuestionsBody: BulkCreateQuestionsBody, options?: RequestInit): Promise<BulkImportResult> => {

  return customFetch<BulkImportResult>(getBulkCreateQuestionsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      bulkCreateQuestionsBody,)
  }
);}




export const getBulkCreateQuestionsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkCreateQuestions>>, TError,{data: BodyType<BulkCreateQuestionsBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkCreateQuestions>>, TError,{data: BodyType<BulkCreateQuestionsBody>}, TContext> => {

const mutationKey = ['bulkCreateQuestions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkCreateQuestions>>, {data: BodyType<BulkCreateQuestionsBody>}> = (props) => {
          const {data} = props ?? {};

          return  bulkCreateQuestions(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkCreateQuestionsMutationResult = NonNullable<Awaited<ReturnType<typeof bulkCreateQuestions>>>
    export type BulkCreateQuestionsMutationBody = BodyType<BulkCreateQuestionsBody>
    export type BulkCreateQuestionsMutationError = ErrorType<unknown>

    /**
 * @summary Bulk import questions
 */
export const useBulkCreateQuestions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkCreateQuestions>>, TError,{data: BodyType<BulkCreateQuestionsBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof bulkCreateQuestions>>,
        TError,
        {data: BodyType<BulkCreateQuestionsBody>},
        TContext
      > => {
      return useMutation(getBulkCreateQuestionsMutationOptions(options));
    }

/**
 * @summary Get a question by ID
 */
export const getGetQuestionUrl = (id: number,) => {




  return `/api/questions/${id}`
}

export const getQuestion = async (id: number, options?: RequestInit): Promise<Question> => {

  return customFetch<Question>(getGetQuestionUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetQuestionQueryKey = (id: number,) => {
    return [
    `/api/questions/${id}`
    ] as const;
    }


export const getGetQuestionQueryOptions = <TData = Awaited<ReturnType<typeof getQuestion>>, TError = ErrorType<ErrorResponse>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getQuestion>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuestionQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuestion>>> = ({ signal }) => getQuestion(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getQuestion>>, TError, TData> & { queryKey: QueryKey }
}

export type GetQuestionQueryResult = NonNullable<Awaited<ReturnType<typeof getQuestion>>>
export type GetQuestionQueryError = ErrorType<ErrorResponse>


/**
 * @summary Get a question by ID
 */

export function useGetQuestion<TData = Awaited<ReturnType<typeof getQuestion>>, TError = ErrorType<ErrorResponse>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getQuestion>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetQuestionQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Delete a question
 */
export const getDeleteQuestionUrl = (id: number,) => {




  return `/api/questions/${id}`
}

export const deleteQuestion = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteQuestionUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteQuestionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteQuestion>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteQuestion>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteQuestion'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteQuestion>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteQuestion(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteQuestionMutationResult = NonNullable<Awaited<ReturnType<typeof deleteQuestion>>>

    export type DeleteQuestionMutationError = ErrorType<unknown>

    /**
 * @summary Delete a question
 */
export const useDeleteQuestion = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteQuestion>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteQuestion>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteQuestionMutationOptions(options));
    }

/**
 * @summary List all practice sessions
 */
export const getListSessionsUrl = () => {




  return `/api/sessions`
}

export const listSessions = async ( options?: RequestInit): Promise<Session[]> => {

  return customFetch<Session[]>(getListSessionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSessionsQueryKey = () => {
    return [
    `/api/sessions`
    ] as const;
    }


export const getListSessionsQueryOptions = <TData = Awaited<ReturnType<typeof listSessions>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSessions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSessionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSessions>>> = ({ signal }) => listSessions({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSessions>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSessionsQueryResult = NonNullable<Awaited<ReturnType<typeof listSessions>>>
export type ListSessionsQueryError = ErrorType<unknown>


/**
 * @summary List all practice sessions
 */

export function useListSessions<TData = Awaited<ReturnType<typeof listSessions>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSessions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSessionsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Start a new practice session
 */
export const getCreateSessionUrl = () => {




  return `/api/sessions`
}

export const createSession = async (createSessionBody: CreateSessionBody, options?: RequestInit): Promise<Session> => {

  return customFetch<Session>(getCreateSessionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createSessionBody,)
  }
);}




export const getCreateSessionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSession>>, TError,{data: BodyType<CreateSessionBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createSession>>, TError,{data: BodyType<CreateSessionBody>}, TContext> => {

const mutationKey = ['createSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSession>>, {data: BodyType<CreateSessionBody>}> = (props) => {
          const {data} = props ?? {};

          return  createSession(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSessionMutationResult = NonNullable<Awaited<ReturnType<typeof createSession>>>
    export type CreateSessionMutationBody = BodyType<CreateSessionBody>
    export type CreateSessionMutationError = ErrorType<unknown>

    /**
 * @summary Start a new practice session
 */
export const useCreateSession = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSession>>, TError,{data: BodyType<CreateSessionBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createSession>>,
        TError,
        {data: BodyType<CreateSessionBody>},
        TContext
      > => {
      return useMutation(getCreateSessionMutationOptions(options));
    }

/**
 * @summary Get a session by ID
 */
export const getGetSessionUrl = (id: number,) => {




  return `/api/sessions/${id}`
}

export const getSession = async (id: number, options?: RequestInit): Promise<Session> => {

  return customFetch<Session>(getGetSessionUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSessionQueryKey = (id: number,) => {
    return [
    `/api/sessions/${id}`
    ] as const;
    }


export const getGetSessionQueryOptions = <TData = Awaited<ReturnType<typeof getSession>>, TError = ErrorType<ErrorResponse>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSession>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSessionQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSession>>> = ({ signal }) => getSession(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSession>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSessionQueryResult = NonNullable<Awaited<ReturnType<typeof getSession>>>
export type GetSessionQueryError = ErrorType<ErrorResponse>


/**
 * @summary Get a session by ID
 */

export function useGetSession<TData = Awaited<ReturnType<typeof getSession>>, TError = ErrorType<ErrorResponse>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSession>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSessionQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Update session (e.g. mark complete)
 */
export const getUpdateSessionUrl = (id: number,) => {




  return `/api/sessions/${id}`
}

export const updateSession = async (id: number,
    updateSessionBody: UpdateSessionBody, options?: RequestInit): Promise<Session> => {

  return customFetch<Session>(getUpdateSessionUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateSessionBody,)
  }
);}




export const getUpdateSessionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSession>>, TError,{id: number;data: BodyType<UpdateSessionBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSession>>, TError,{id: number;data: BodyType<UpdateSessionBody>}, TContext> => {

const mutationKey = ['updateSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSession>>, {id: number;data: BodyType<UpdateSessionBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateSession(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSessionMutationResult = NonNullable<Awaited<ReturnType<typeof updateSession>>>
    export type UpdateSessionMutationBody = BodyType<UpdateSessionBody>
    export type UpdateSessionMutationError = ErrorType<unknown>

    /**
 * @summary Update session (e.g. mark complete)
 */
export const useUpdateSession = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSession>>, TError,{id: number;data: BodyType<UpdateSessionBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateSession>>,
        TError,
        {id: number;data: BodyType<UpdateSessionBody>},
        TContext
      > => {
      return useMutation(getUpdateSessionMutationOptions(options));
    }

/**
 * @summary Get all questions for a session
 */
export const getGetSessionQuestionsUrl = (id: number,) => {




  return `/api/sessions/${id}/questions`
}

export const getSessionQuestions = async (id: number, options?: RequestInit): Promise<Question[]> => {

  return customFetch<Question[]>(getGetSessionQuestionsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSessionQuestionsQueryKey = (id: number,) => {
    return [
    `/api/sessions/${id}/questions`
    ] as const;
    }


export const getGetSessionQuestionsQueryOptions = <TData = Awaited<ReturnType<typeof getSessionQuestions>>, TError = ErrorType<ErrorResponse>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSessionQuestions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSessionQuestionsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSessionQuestions>>> = ({ signal }) => getSessionQuestions(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSessionQuestions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSessionQuestionsQueryResult = NonNullable<Awaited<ReturnType<typeof getSessionQuestions>>>
export type GetSessionQuestionsQueryError = ErrorType<ErrorResponse>


/**
 * @summary Get all questions for a session
 */

export function useGetSessionQuestions<TData = Awaited<ReturnType<typeof getSessionQuestions>>, TError = ErrorType<ErrorResponse>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSessionQuestions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSessionQuestionsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Submit an answer for a question in a session
 */
export const getSubmitAnswerUrl = () => {




  return `/api/answers`
}

export const submitAnswer = async (submitAnswerBody: SubmitAnswerBody, options?: RequestInit): Promise<AnswerResult> => {

  return customFetch<AnswerResult>(getSubmitAnswerUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      submitAnswerBody,)
  }
);}




export const getSubmitAnswerMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitAnswer>>, TError,{data: BodyType<SubmitAnswerBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof submitAnswer>>, TError,{data: BodyType<SubmitAnswerBody>}, TContext> => {

const mutationKey = ['submitAnswer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitAnswer>>, {data: BodyType<SubmitAnswerBody>}> = (props) => {
          const {data} = props ?? {};

          return  submitAnswer(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitAnswerMutationResult = NonNullable<Awaited<ReturnType<typeof submitAnswer>>>
    export type SubmitAnswerMutationBody = BodyType<SubmitAnswerBody>
    export type SubmitAnswerMutationError = ErrorType<unknown>

    /**
 * @summary Submit an answer for a question in a session
 */
export const useSubmitAnswer = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitAnswer>>, TError,{data: BodyType<SubmitAnswerBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof submitAnswer>>,
        TError,
        {data: BodyType<SubmitAnswerBody>},
        TContext
      > => {
      return useMutation(getSubmitAnswerMutationOptions(options));
    }

/**
 * @summary List all answers for a session
 */
export const getListSessionAnswersUrl = (sessionId: number,) => {




  return `/api/answers/session/${sessionId}`
}

export const listSessionAnswers = async (sessionId: number, options?: RequestInit): Promise<AnswerRecord[]> => {

  return customFetch<AnswerRecord[]>(getListSessionAnswersUrl(sessionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSessionAnswersQueryKey = (sessionId: number,) => {
    return [
    `/api/answers/session/${sessionId}`
    ] as const;
    }


export const getListSessionAnswersQueryOptions = <TData = Awaited<ReturnType<typeof listSessionAnswers>>, TError = ErrorType<unknown>>(sessionId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSessionAnswers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSessionAnswersQueryKey(sessionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSessionAnswers>>> = ({ signal }) => listSessionAnswers(sessionId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(sessionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSessionAnswers>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSessionAnswersQueryResult = NonNullable<Awaited<ReturnType<typeof listSessionAnswers>>>
export type ListSessionAnswersQueryError = ErrorType<unknown>


/**
 * @summary List all answers for a session
 */

export function useListSessionAnswers<TData = Awaited<ReturnType<typeof listSessionAnswers>>, TError = ErrorType<unknown>>(
 sessionId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSessionAnswers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSessionAnswersQueryOptions(sessionId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Get overall performance statistics
 */
export const getGetStatsOverviewUrl = (params?: GetStatsOverviewParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/stats/overview?${stringifiedParams}` : `/api/stats/overview`
}

export const getStatsOverview = async (params?: GetStatsOverviewParams, options?: RequestInit): Promise<StatsOverview> => {

  return customFetch<StatsOverview>(getGetStatsOverviewUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetStatsOverviewQueryKey = (params?: GetStatsOverviewParams,) => {
    return [
    `/api/stats/overview`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetStatsOverviewQueryOptions = <TData = Awaited<ReturnType<typeof getStatsOverview>>, TError = ErrorType<unknown>>(params?: GetStatsOverviewParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStatsOverview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStatsOverviewQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStatsOverview>>> = ({ signal }) => getStatsOverview(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStatsOverview>>, TError, TData> & { queryKey: QueryKey }
}

export type GetStatsOverviewQueryResult = NonNullable<Awaited<ReturnType<typeof getStatsOverview>>>
export type GetStatsOverviewQueryError = ErrorType<unknown>


/**
 * @summary Get overall performance statistics
 */

export function useGetStatsOverview<TData = Awaited<ReturnType<typeof getStatsOverview>>, TError = ErrorType<unknown>>(
 params?: GetStatsOverviewParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStatsOverview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetStatsOverviewQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Per-track question counts (for showing study programmes with enough content)
 */
export const getGetBankCountsUrl = () => {




  return `/api/stats/bank-counts`
}

export const getBankCounts = async ( options?: RequestInit): Promise<BankCounts> => {

  return customFetch<BankCounts>(getGetBankCountsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetBankCountsQueryKey = () => {
    return [
    `/api/stats/bank-counts`
    ] as const;
    }


export const getGetBankCountsQueryOptions = <TData = Awaited<ReturnType<typeof getBankCounts>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBankCounts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBankCountsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBankCounts>>> = ({ signal }) => getBankCounts({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBankCounts>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBankCountsQueryResult = NonNullable<Awaited<ReturnType<typeof getBankCounts>>>
export type GetBankCountsQueryError = ErrorType<unknown>


/**
 * @summary Per-track question counts (for showing study programmes with enough content)
 */

export function useGetBankCounts<TData = Awaited<ReturnType<typeof getBankCounts>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBankCounts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetBankCountsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Get weakest questions (most frequently wrong)
 */
export const getGetWeaknessesUrl = (params?: GetWeaknessesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/stats/weaknesses?${stringifiedParams}` : `/api/stats/weaknesses`
}

export const getWeaknesses = async (params?: GetWeaknessesParams, options?: RequestInit): Promise<WeaknessEntry[]> => {

  return customFetch<WeaknessEntry[]>(getGetWeaknessesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetWeaknessesQueryKey = (params?: GetWeaknessesParams,) => {
    return [
    `/api/stats/weaknesses`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetWeaknessesQueryOptions = <TData = Awaited<ReturnType<typeof getWeaknesses>>, TError = ErrorType<unknown>>(params?: GetWeaknessesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWeaknesses>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWeaknessesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWeaknesses>>> = ({ signal }) => getWeaknesses(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWeaknesses>>, TError, TData> & { queryKey: QueryKey }
}

export type GetWeaknessesQueryResult = NonNullable<Awaited<ReturnType<typeof getWeaknesses>>>
export type GetWeaknessesQueryError = ErrorType<unknown>


/**
 * @summary Get weakest questions (most frequently wrong)
 */

export function useGetWeaknesses<TData = Awaited<ReturnType<typeof getWeaknesses>>, TError = ErrorType<unknown>>(
 params?: GetWeaknessesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWeaknesses>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetWeaknessesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Get performance breakdown by category
 */
export const getGetCategoryStatsUrl = (params?: GetCategoryStatsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/stats/categories?${stringifiedParams}` : `/api/stats/categories`
}

export const getCategoryStats = async (params?: GetCategoryStatsParams, options?: RequestInit): Promise<CategoryStat[]> => {

  return customFetch<CategoryStat[]>(getGetCategoryStatsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCategoryStatsQueryKey = (params?: GetCategoryStatsParams,) => {
    return [
    `/api/stats/categories`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCategoryStatsQueryOptions = <TData = Awaited<ReturnType<typeof getCategoryStats>>, TError = ErrorType<unknown>>(params?: GetCategoryStatsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCategoryStats>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCategoryStatsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCategoryStats>>> = ({ signal }) => getCategoryStats(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCategoryStats>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCategoryStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getCategoryStats>>>
export type GetCategoryStatsQueryError = ErrorType<unknown>


/**
 * @summary Get performance breakdown by category
 */

export function useGetCategoryStats<TData = Awaited<ReturnType<typeof getCategoryStats>>, TError = ErrorType<unknown>>(
 params?: GetCategoryStatsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCategoryStats>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCategoryStatsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Get computed study milestones and badge progress for the active track
 */
export const getGetStatsMilestonesUrl = (params?: GetStatsMilestonesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/stats/milestones?${stringifiedParams}` : `/api/stats/milestones`
}

export const getStatsMilestones = async (params?: GetStatsMilestonesParams, options?: RequestInit): Promise<StatsMilestones> => {

  return customFetch<StatsMilestones>(getGetStatsMilestonesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetStatsMilestonesQueryKey = (params?: GetStatsMilestonesParams,) => {
    return [
    `/api/stats/milestones`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetStatsMilestonesQueryOptions = <TData = Awaited<ReturnType<typeof getStatsMilestones>>, TError = ErrorType<unknown>>(params?: GetStatsMilestonesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStatsMilestones>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStatsMilestonesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStatsMilestones>>> = ({ signal }) => getStatsMilestones(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStatsMilestones>>, TError, TData> & { queryKey: QueryKey }
}

export type GetStatsMilestonesQueryResult = NonNullable<Awaited<ReturnType<typeof getStatsMilestones>>>
export type GetStatsMilestonesQueryError = ErrorType<unknown>


/**
 * @summary Get computed study milestones and badge progress for the active track
 */

export function useGetStatsMilestones<TData = Awaited<ReturnType<typeof getStatsMilestones>>, TError = ErrorType<unknown>>(
 params?: GetStatsMilestonesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStatsMilestones>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetStatsMilestonesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







